var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return !_vm.isButtonType
    ? _c(
        "div",
        {
          directives: [{ name: "wave", rawName: "v-wave" }],
          class: { "cursor-not-allowed": _vm.disabled },
          attrs: { disabled: _vm.disabled },
          on: { click: _vm.onClick },
        },
        [_vm._t("default")],
        2
      )
    : _c(
        "button",
        {
          directives: [{ name: "wave", rawName: "v-wave" }],
          attrs: { disabled: _vm.disabled },
          on: { click: _vm.onClick },
        },
        [_vm._t("default")],
        2
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }